export const SET_SELECTED_PRODUCT = 'GUARANTEE_PURCHASES/SET_SELECTED_PRODUCT';
export const RESET_SELECTED_PRODUCT = 'GUARANTEE_PURCHASES/RESET_SELECTED_PRODUCT';
